import { render, staticRenderFns } from "./NewOrganizerMessage.vue?vue&type=template&id=5e892520&scoped=true"
import script from "./NewOrganizerMessage.vue?vue&type=script&lang=js"
export * from "./NewOrganizerMessage.vue?vue&type=script&lang=js"
import style0 from "./NewOrganizerMessage.vue?vue&type=style&index=0&id=5e892520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e892520",
  null
  
)

export default component.exports